"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class PreviewCreator {
    createPreview(file) {
        const fileType = file.type || 'unknown';
        const url = URL.createObjectURL(file);
        console.log(fileType);
        if (fileType.startsWith('image/')) {
            return this.createImagePreview(url);
        }
        else if (fileType.startsWith('video/')) {
            return this.createVideoPreview(url);
        }
        else if (fileType.startsWith('audio/')) {
            return this.createAudioPreview(url);
        }
        else if (fileType === 'application/pdf') {
            return this.createPdfPreview(url);
        }
        else {
            return null;
        }
    }
    createImagePreview(url) {
        const image = document.createElement('img');
        image.src = url;
        return image;
    }
    createVideoPreview(url) {
        const video = document.createElement('video');
        video.src = url;
        video.controls = true;
        return video;
    }
    createAudioPreview(url) {
        const audio = document.createElement('audio');
        audio.src = url;
        audio.controls = true;
        return audio;
    }
    createPdfPreview(url) {
        const pdfFrame = document.createElement('iframe');
        pdfFrame.src = url;
        pdfFrame.style.width = '100%';
        pdfFrame.style.height = '100%';
        pdfFrame.style.border = 'none';
        return pdfFrame;
    }
}
exports.default = PreviewCreator;
